module.exports = __webpack_public_path__ + "img/nav-gradient.6591e80a.png";